import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ehrAppointmentSchedulingInfoSelector } from '../../models/nutritionistHub.selectors'

interface StressManagementSchedulingInfoHookParams {
  skip?: boolean
}

export const useStressManagementSchedulingInfo = ({
  skip = false,
}: StressManagementSchedulingInfoHookParams = {}) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(() => !skip)
  const [error, setError] = useState<any>()

  useEffect(() => {
    if (skip) {
      return
    }
    dispatch({
      type: 'nutritionistHub/fetchAppointmentSchedulingInfo',
      success: () => setLoading(false),
      failure: (error) => setError(error),
    })
  }, [skip, dispatch, setLoading])

  const appointmentSchedulingInfo = useSelector(ehrAppointmentSchedulingInfoSelector)
  const schedulingInfo = appointmentSchedulingInfo?.stressManagement

  return { schedulingInfo, loading, error }
}
